/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandBinance = createReactComponent("outline", "brand-binance", "IconBrandBinance", [["path", { "d": "M6 8l2 2l4 -4l4 4l2 -2l-6 -6z", "key": "svg-0" }], ["path", { "d": "M6 16l2 -2l4 4l3.5 -3.5l2 2l-5.5 5.5z", "key": "svg-1" }], ["path", { "d": "M20 10l2 2l-2 2l-2 -2z", "key": "svg-2" }], ["path", { "d": "M4 10l2 2l-2 2l-2 -2z", "key": "svg-3" }], ["path", { "d": "M12 10l2 2l-2 2l-2 -2z", "key": "svg-4" }]]);

export { IconBrandBinance as default };
//# sourceMappingURL=IconBrandBinance.mjs.map
